import { memo } from 'react'

import Admin from './Admin'

const AdminComponent = memo(Admin)

export default AdminComponent
